(function (Translator) {
    // fr
    Translator.add("rate_list.rate.bg_kbcbank", "Montant de KBC Bank", "EvpThemeBundle", "fr");
    Translator.add("recaptcha.description", "Ce message est destin\u00e9 \u00e0 v\u00e9rifier si une personne navigue et \u00e0 \u00e9viter les syst\u00e8mes de contr\u00f4le automatique.", "EvpThemeBundle", "fr");
    Translator.add("recaptcha.title", "\u00cates-vous un robot ?", "EvpThemeBundle", "fr");
})(Translator);
